export default __webpack_public_path__ + "static/media/quote.68bcec17.svg";